import React, { useState, useEffect } from 'react';
import { Autoplay, FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getCityData } from '../../utils/city-data';
import { useGetSlidesQuery } from '../../modules/slides/api';
import Spinner from '../spinner/Spinner';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const Slider = ({ city }) => {
    const [isMobile, setIsMobile] = useState(false);
    const [tooltipVisibleIndex, setTooltipVisibleIndex] = useState(null);
    const cityData = getCityData(city);
    const { data: slides, isLoading, isError } = useGetSlidesQuery(cityData.url);

    useEffect(() => {
        const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        setIsMobile(isMobileDevice);
    }, []);

    if (isLoading) return <Spinner />;
    if (isError) return <p>Error loading slides</p>;

    return (
        <Swiper
            modules={[Autoplay, FreeMode]}
            slidesPerView={isMobile ? 1 : 3}
            spaceBetween={30}
            freeMode={true}
            autoplay={{
                delay: 3500,
                disableOnInteraction: false,
            }}
            loop={true}
            className="mySwiper row"
        >
            {slides.data.map((slide, index) => {
                const hasImage = slide.media && slide.media.length > 0;
                const imageUrl = hasImage ? slide.media[0].url : null;
                const isAd = slide.is_advertising;
                const hasAdInfo = slide.advertiser_name && slide.advertiser_inn && slide.advertiser_erid;

                const showTooltip = tooltipVisibleIndex === index;

                const imageElement = imageUrl && (
                    <div className="slide-wrapper">
                        <img
                            src={imageUrl}
                            className="img-fluid mx-auto d-block"
                            alt={`img${index}`}
                            style={{ borderRadius: '10px' }}
                        />
                        {isAd && (
                            <div
                                className="ad-label"
                                onMouseEnter={() => setTooltipVisibleIndex(index)}
                                onMouseLeave={() => setTooltipVisibleIndex(null)}
                            >
                                Реклама
                                {hasAdInfo && showTooltip && (
                                    <div
                                        className="ad-tooltip"
                                        onMouseEnter={() => setTooltipVisibleIndex(index)}
                                        onMouseLeave={() => setTooltipVisibleIndex(null)}
                                    >
                                        <div>ООО «{slide.advertiser_name}»</div>
                                        <div>ИНН {slide.advertiser_inn}</div>
                                        <div>ЕРИД {slide.advertiser_erid}</div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                );

                return (
                    <SwiperSlide key={index}>
                        {slide.restaurant_id ? (
                            <a href={`/City-${cityData.urlName}/shop-${slide.restaurant_name}`}>
                                {imageElement}
                            </a>
                        ) : (
                            imageElement
                        )}
                    </SwiperSlide>
                );
            })}
        </Swiper>
    );
};

export default Slider;